import { routeBuilderHelper, routesBuilder } from '@guiker/shared-framework'

import { StockOrder, StockOrderStatus, StockOrderWriteModel } from '../../../../../entity'
import { paths } from '../../../paths'

const { buildGet } = routesBuilder<StockOrder, StockOrderWriteModel>()({
  basePath: paths.stock.withId.stockOrders.path,
})

export const routes = {
  readAllStockOrdersByStock: buildGet(routeBuilderHelper.withStatus(Object.values(StockOrderStatus))),
}
